import React from 'react';
import PropTypes from 'prop-types';
import './WelcomePopup.css';
import { Button } from '../../Button';
import WelcomeSvg from './welcome.svg';

export const WelcomePopup = ({ handleNext, userName }) => (
  <div className="a">
    <div className="row">
      <div className="col-12 p-0">
        <img alt="welcome" className="imag-modal w-100" src={WelcomeSvg} />
      </div>
    </div>
    <div className="row py-4 text-center">
      <div className="col">
        <div className="h5 t-30 t-md-38">Welcome {userName},</div>
        <p className="t-16 t-md-17">
          {"Let's create your brief in just a few easy steps!"}
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col text-center pb-2">
        <Button
          onClick={handleNext}
          className="btn-primary px-7"
          rounded
          title="Next"
        />
      </div>
    </div>
  </div>
);

WelcomePopup.propTypes = {
  handleNext: PropTypes.func,
  userName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Popup/WelcomePopup/WelcomePopup.js